import styled from 'styled-components';

const CookieText = styled.div`
  a {
    color: ${({ theme }) => theme.extend.colors.primary.default};
    text-decoration: underline;
  }
`;

export default CookieText;
export { CookieText };
